
















































import { mapGetters, mapState } from 'vuex'
import ListFilters from '@/components/ListFilters.vue'
import DateRangePicker from '@/components/DateRangePicker.vue'
import DropdownFilter from '@/components/DropdownFilter.vue'
import AddressTypeAhead from '../components/AddressTypeAhead.vue'
import {
  MarketplaceLocation,
  prepareLocationData,
  prepareSelectedLocation
} from '../marketplace-location'
import LoadDimensionsFilters from '@/components/LoadDimensionsFilters.vue'
import RadiusFilter from '@/modules/marketplace/components/RadiusFilter.vue'
import RadiusAddressWrapper from '@/modules/marketplace/components/RadiusAddressWrapper.vue'

export default {
  components: {
    ListFilters,
    DateRangePicker,
    DropdownFilter,
    AddressTypeAhead,
    LoadDimensionsFilters,
    RadiusFilter,
    RadiusAddressWrapper
  },
  data() {
    return {
      options: []
    }
  },
  computed: {
    ...mapGetters(['marketplaceFilters']),
    ...mapState(['vehicleTypes']),
    initialFilterValues() {
      const {
        pickupPlaceId,
        dropOffPlaceId,
        pickupRangeStart,
        pickupRangeEnd,
        dropOffRangeStart,
        dropOffRangeEnd,
        pickupLocationName,
        dropOffLocationName,
        vehicleType,
        minWeight,
        maxWeight,
        maxHeight,
        maxWidth,
        maxLength,
        pickupRadius,
        dropOffRadius
      } = this.marketplaceFilters || {}

      return {
        pickupRadius,
        dropOffRadius,
        pickupRange: {
          pickupRangeStart,
          pickupRangeEnd
        },
        dropOffRange: {
          dropOffRangeStart,
          dropOffRangeEnd
        },
        dropOffLocation: prepareLocationData(dropOffPlaceId, dropOffLocationName),
        pickupLocation: prepareLocationData(pickupPlaceId, pickupLocationName),
        vehicleType,
        loadDimensions: {
          weight: {
            minWeight,
            maxWeight
          },
          maxHeight,
          maxWidth,
          maxLength
        }
      }
    }
  },
  methods: {
    prepareLocation(location: MarketplaceLocation): Array<MarketplaceLocation> {
      return prepareSelectedLocation(location)
    }
  }
}
